import React from "react";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { MuiRadioGroupWrapper } from "./MuiRadioGroup.style";
import { MuiTypography } from "../typography/MuiTypography";
import { useNavigationSiteCore } from "../../hooks/useNavigationSiteCore";
import { replaceHashWithValue } from "../../helpers/utils";

interface RadioGroupProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options: { value: string; label: string }[];
  disabled?: boolean;
  isMandatory?: boolean;
  wrapperClassName?: string;
  requiredARIALabel: string;
}

export const MuiRadioGroup: React.FC<RadioGroupProps> = ({
  label,
  value,
  onChange,
  options,
  disabled = false,
  isMandatory = false,
  wrapperClassName = "",
  requiredARIALabel = "Required",
}) => {
  const { commonARIALabel } = useNavigationSiteCore();
  return (
    <MuiRadioGroupWrapper className={wrapperClassName}>
      {label && (
        <MuiTypography
          className={`radio-heading ${disabled ? "mui-label disabled" : "mui-label"}`}
          component="label"
          variant="h3"
        >
          {label}{" "}
          {isMandatory && (
            <label className="asterisk" aria-label={requiredARIALabel}>
              *
            </label>
          )}
        </MuiTypography>
      )}
      <RadioGroup row value={value} onChange={onChange}>
        {options.map((option, index) => {
          return (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio tabIndex={index == 0 ? 0 : -1} />}
              label={option.label}
              aria-label={option.label}
            />
          );
        })}
      </RadioGroup>
    </MuiRadioGroupWrapper>
  );
};
